"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tr = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledBaseComponents = require("styled-base-components");

var _styledConfig = require("styled-config");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    & > th,\n    & > td {\n      background-color: ", ";\n    }\n    .hover &:hover > th,\n    .hover &:hover > td,\n    .hover & tbody tr:hover,\n    .hover & tbody tr:hover > th,\n    .hover & tbody tr:hover > td {\n      background-color: ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      & > th,\n      & > td,\n      & tbody tr:hover,\n      & tbody tr:hover > th,\n      & tbody tr:hover > td {\n        background-color: ", ";\n      };\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var color = function color(props) {
  if (props.active) {
    return (0, _styledComponents.css)(_templateObject(), (0, _styledConfig.getColor)(props, 'tr', 'activeBackgroundColor'));
  } // Hover is used as workaround for making Tr hoverable if Table if hoverable


  return (0, _styledComponents.css)(_templateObject2(), (0, _styledConfig.getColor)(props, 'tr', 'backgroundColor'), (0, _styledConfig.getColor)(props, 'tr', 'backgroundColorHoverFocus'));
};

var Tr = (0, _styledComponents.default)(_styledBaseComponents.Tr)(_templateObject3(), function (props) {
  return color(props);
});
exports.Tr = Tr;
Tr.defaultProps = {
  theme: _styledConfig.theme
};